import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const EFFECTIVE_DATE = "February 14, 2026";

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen" style={{ background: "#1a1a1e" }} data-testid="terms-page">
      <div className="border-b border-gray-800" style={{ background: "#0f0f11" }}>
        <div className="container-custom py-4">
          <Link to="/"><Button variant="ghost" className="text-purple-400" data-testid="terms-back">← Back</Button></Link>
        </div>
      </div>
      <div className="container-custom py-12">
        <div className="max-w-4xl mx-auto">
          <Card className="p-8" style={{ background: "rgba(42, 26, 58, 0.5)", borderColor: "rgba(138, 43, 226, 0.3)" }}>
            <h1 className="text-4xl font-bold text-white mb-2">Terms of Service</h1>
            <p className="text-sm text-purple-300 mb-8">Effective Date: {EFFECTIVE_DATE}</p>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p>
                Welcome to RGM Studio. By accessing or using our platform you agree to these Terms of Service.
                Please read them carefully — if you do not agree, do not use the platform.
              </p>

              <h2 className="text-2xl font-bold text-white">1. Eligibility</h2>
              <p>You must be at least 13 years old to create an account. If you are under 18 you must have permission from a parent or legal guardian.</p>

              <h2 className="text-2xl font-bold text-white">2. Your Account</h2>
              <p>You are responsible for the activity on your account, the accuracy of the information you provide, and the security of your login credentials.</p>

              <h2 className="text-2xl font-bold text-white">3. Creator Content</h2>
              <p>You retain ownership of the music, cover art, images, videos, and other creator content you upload. By uploading, you grant RGM Studio a worldwide, non-exclusive, royalty-free license to host, store, display, distribute, promote, and feature your content on the platform and across RGM-owned marketing surfaces.</p>

              <h2 className="text-2xl font-bold text-white">4. Acceptable Use</h2>
              <p>You may not upload, post, transmit, or distribute content that is illegal, hateful, harassing, fraudulent, sexually exploitative, infringing, or otherwise violates the Community Guidelines. RGM Studio may remove content and suspend or terminate accounts that violate these rules.</p>

              <h2 className="text-2xl font-bold text-white">5. Virtual Coins, Gifts, and Payouts</h2>
              <p>Coins, gifts, and any in-app virtual currency are licensed for use inside RGM Studio and have no monetary value outside the platform. Creator payouts are subject to our Creator Monetization Policy, including hold periods, eligibility, and conversion rate.</p>

              <h2 className="text-2xl font-bold text-white">6. Live Beams</h2>
              <p>By going live or joining a Live Beam, you agree to follow the Beam rules, behave respectfully, and acknowledge that hosts and monitors may remove participants who break the rules.</p>

              <h2 className="text-2xl font-bold text-white">7. Third-Party Services</h2>
              <p>The platform integrates with third-party services for hosting, payments, analytics, and media delivery. Your use of those services is also subject to their respective terms.</p>

              <h2 className="text-2xl font-bold text-white">8. Termination</h2>
              <p>RGM Studio may suspend or terminate your access to the platform if you breach these Terms, the Community Guidelines, or for any other reasonable cause.</p>

              <h2 className="text-2xl font-bold text-white">9. Disclaimers & Limitation of Liability</h2>
              <p>The platform is provided "as is" without warranties of any kind. To the maximum extent permitted by law, RGM Studio is not liable for any indirect, incidental, or consequential damages.</p>

              <h2 className="text-2xl font-bold text-white">10. Changes</h2>
              <p>We may update these Terms from time to time. Material changes will be announced in the app or via email. Continued use after changes constitutes acceptance.</p>

              <h2 className="text-2xl font-bold text-white">11. Contact</h2>
              <p>📧 <a className="text-purple-300 underline" href="mailto:realglobalmusicent@yahoo.com">realglobalmusicent@yahoo.com</a></p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
